export default "__VITE_ASSET__2d942744__"